import PropTypes from 'prop-types';
import classnames from 'classnames';
import slugify from 'dibs-slugify/exports/slugify.ts';

//components
import { FormattedNumber } from 'dibs-react-intl';
import { Checkbox } from 'dibs-elements/exports/Checkbox.tsx';
import { AbsoluteAnchor } from '../../../global/AbsoluteAnchor/AbsoluteAnchor.jsx';

import { useSbSelector } from '../../../reducers/useSbSelector.ts';
import { useServerVarsContext } from '../../../global/ServerVarsContext/ServerVarsContext.tsx';

// styles
import styles from './SbSharedRefineMenuInput.scss';
import dibsCss from 'dibs-css';

export function SbSharedRefineMenuInputCheckbox(props) {
    const {
        text,
        count,
        className,
        value,
        checked,
        onChange,
        linkReference,
        linkable,
        isHidden,
        isDisabled,
        checkboxId,
    } = props;
    const containerClass = classnames(styles.container, className, {
        'is-hidden': isHidden,
    });
    const { isQuickFiltersRedesignVariant, isRemoveCountsVariant } = useServerVarsContext();
    const refetchInFlight = useSbSelector(state => state.filters.refetchInFlight);
    const anchorClass = classnames(styles.anchor, {
        [styles.disabled]: isDisabled || refetchInFlight,
        [dibsCss.textIron]: (isDisabled || refetchInFlight) && isQuickFiltersRedesignVariant,
    });
    const shouldDisplayCount = typeof count === 'number' && !isRemoveCountsVariant;

    // put AbsoluteAnchor inside label to prevent click and focus stealing
    const label = (
        <AbsoluteAnchor
            linkReference={linkReference}
            linkable={linkable}
            className={anchorClass}
            onClick={e => e.preventDefault()}
            inert
        >
            {text}
        </AbsoluteAnchor>
    );

    return (
        <div className={containerClass}>
            <Checkbox
                id={checkboxId}
                wrapperClass={styles.inputWrapper}
                labelClass={styles.label}
                value={value}
                checked={checked}
                name={text}
                label={label}
                onChange={onChange}
                disabled={isDisabled || refetchInFlight}
                dataTn={`facet-content-${slugify(text)}`}
            />

            {shouldDisplayCount && (
                <span
                    className={classnames(
                        styles.count,
                        dibsCss.mt3px,
                        dibsCss.mlXsmall,
                        (refetchInFlight || isDisabled) && isQuickFiltersRedesignVariant
                            ? dibsCss.textIron
                            : dibsCss.textSatan
                    )}
                    data-tn={`facet-count-${slugify(text)}`}
                >
                    <FormattedNumber value={count} />
                </span>
            )}
        </div>
    );
}

SbSharedRefineMenuInputCheckbox.propTypes = {
    count: PropTypes.number,
    text: PropTypes.string.isRequired,
    className: PropTypes.string,
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    linkReference: PropTypes.string,
    linkable: PropTypes.bool,
    isHidden: PropTypes.bool,
    isDisabled: PropTypes.bool,
    checkboxId: PropTypes.string,
};
